const generator = require('generate-password');

export const generateUsername = (username) => {
    try {
        return `${username.replace(/ /g, '').replace(/,/g, '_')}_${generator.generate({
            length: 5,
            numbers: true,
        })}`;
    } catch (err) {
        console.log(err);
    }
};

export const generatePassword = () => {
    return generator.generate({
        length: 10,
        numbers: true,
    });
};
